import { render } from "./LabelLink.vue?vue&type=template&id=5984f51c&scoped=true&ts=true"
import script from "./LabelLink.vue?vue&type=script&lang=ts"
export * from "./LabelLink.vue?vue&type=script&lang=ts"

import "./LabelLink.vue?vue&type=style&index=0&id=5984f51c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5984f51c"]])

export default __exports__